module.exports = __webpack_public_path__ + "static/media/fut_liquid_verbs_img.fa9dfbbb.JPG";